/**
 * Build user-visible messages from upload-pdf error payloads.
 */
export function getUploadErrorMessage(data) {
  if (!data) return 'Failed to process PDF.';

  if (data.split_required) {
    const message = data.message || 'This PDF is too large to process in one upload.';
    const splitMessage = data.split_message || 'Please split it into smaller PDFs, then upload each part.';
    return `${message}\n\n${splitMessage}`;
  }

  if (data.message && typeof data.message === 'string') {
    return data.message;
  }

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error;
  }

  const details = data.failed_file_details;
  if (Array.isArray(details) && details.length > 0) {
    if (details.length === 1) {
      return details[0].message || data.error || 'Could not open the PDF.';
    }
    return (
      'Could not open some PDF files:\n' +
      details.map((d) => `• ${d.message || d.filename}`).join('\n')
    );
  }

  return 'Failed to process PDF.';
}

export function uploadNeedsPasswordHint(data) {
  if (!data) return false;
  if (data.password_required) return true;
  const details = data.failed_file_details;
  return (
    Array.isArray(details) &&
    details.some((d) => d.reason === 'password_required' || d.reason === 'password_incorrect')
  );
}
